import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldSchemesConfigureRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-schemes-configure',
	path: '/secure/admin/ConfigureFieldScreenScheme.jspa',
};
